<template>
    <div class="row mt-4">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <h5 class="mb-0">Patient Notes</h5>

                    <div v-if="notes.length">
                        <div class="note mt-4" v-for="(note, index) in notes" :key="index">
                            <div class="note-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                <div><p class="mb-0 creator">{{ note.practitionerName }}</p></div>
                                <div><p class="mb-0 text-sm"><span class="font-weight-bold font-italic mr-4">Patient note</span> {{ note.dateCreated | moment("DD/MM/YYYY HH:mm")}}</p></div>
                            </div>

                            <div class="note-body text-sm">
                                {{ note.text }}
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <textarea class="form-control note" :class="{'border border-danger' : errors.length}" rows="4" placeholder="Add a note to the patient" v-model="newNote"></textarea>
                        <small class="d-block text-danger">{{ errors[0] }}</small>

                        <div class="text-right">
                            <button :disabled="loading" @click="addNote()" class="btn btn-secondary sm-shadow mt-3 px-45" :class="{disabled : loading}">Save <span v-if="loading" class="btn-loading"></span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'PatientNotesComponent',

    props: {
        patientId: String,
        notes: Array,
        reloading: Boolean(false)
    },

    data() {
        return {
            loading: false,
            newNote: '',
            errors: []
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId',
            practitionerId: 'UserStore/GetUserPractitionerId',
            userFullName: 'UserStore/GetUserFullName'
        })
    },

    methods: {
        ...mapActions({
            setNotification: 'NotificationStore/SetNotification'
        }),

        async addNote() {
            this.checkForm()

            if(!this.errors.length) {
                this.loading = true

                let noteModel = {
                    practitionerId: this.practitionerId,
                    practitionerName: this.userFullName,
                    text: this.newNote
                }

                try {
                    await axios.post(`${process.env.VUE_APP_AXIOS_PATIENT_BASE_URL}/api/v1/patientnotes/${this.organisationId}/${this.$route.params.id}`, noteModel)

                    this.newNote = ''

                    this.$emit('reload')
                }
                catch(err) {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'Something went wrong. Please try again'
                    })
                }
                finally {
                    this.loading = false
                }
            }            
        },

        checkForm() {
            this.errors = []

            if(!this.newNote) {
                this.errors.push("The note field is required")
            }
        }
    }
}
</script>